"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsCounter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CounterPluralize = _interopRequireDefault(require("../../CounterPluralize"));
var _excluded = ["value", "onValueChange", "minValue", "maxValue", "isMobile"];
var NightsCounter = exports.NightsCounter = function NightsCounter(props) {
  var value = props.value,
    onValueChange = props.onValueChange,
    minValue = props.minValue,
    maxValue = props.maxValue,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledCounterPluralize, (0, _extends2["default"])({
    value: value,
    fontSize: isMobile ? 16 : 14,
    onChange: onValueChange,
    minValue: minValue,
    maxValue: maxValue
  }, otherProps)));
};
var StyledCounterPluralize = (0, _styledComponents["default"])(_CounterPluralize["default"]).withConfig({
  displayName: "NightsCounter__StyledCounterPluralize",
  componentId: "sc-17c372v-0"
})(["height:50px;padding:0 10px;"]);